import { FC, Fragment, useCallback, useState } from "react";
import { Modal, ModalBody, ModalBodyRenderProps } from "./Modal";
import { NewShotForm } from "./NewShotForm";
import { useHotkeys } from "react-hotkeys-hook";
import { ADD_SHOT } from "../hotkeys";

export const NewShotController: FC = () => {
  const [isEditing, setIsEditing] = useState(false);

  const onEdit = useCallback(() => {
    setIsEditing(true);
  }, []);

  const onCancelEdit = useCallback(() => {
    setIsEditing(false);
  }, []);

  const renderModalBody = useCallback(
    ({ closeModal }: ModalBodyRenderProps) => (
      <ModalBody>
        <NewShotForm onCreated={closeModal} />
      </ModalBody>
    ),
    []
  );

  useHotkeys(ADD_SHOT, (event: KeyboardEvent) => {
    event.preventDefault();
    setIsEditing(true);
  });

  return (
    <Fragment>
      <button onClick={onEdit}>Add shot</button>
      <Modal isOpen={isEditing} title="Add shot" onClose={onCancelEdit}>
        {renderModalBody}
      </Modal>
    </Fragment>
  );
};
